module.exports = __webpack_public_path__ + "img/bg-dark5.7577780f.jpg";